if (typeof window.sr_collection_grids == 'undefined') {
    window.sr_collection_grids = true;
    document.addEventListener('DOMContentLoaded', () => {
        const collectionGrids = document.querySelectorAll('[data-section-type="collection-grid-section"]');
        collectionGrids.forEach(collectionGrid => {
            const navTriggers = collectionGrid.querySelectorAll('[js-collection-grid-nav-trigger]');
            const sortWraps = collectionGrid.querySelectorAll('[js-collection-grid-sort-wrapper]');
            const collectionBlocks = collectionGrid.querySelectorAll('[js-collection-grid-block]');

            function sortProducts(method) {
                collectionBlocks.forEach(collectionBlock => {
                    const collectionProducts = collectionBlock.querySelectorAll('[js-collection-grid-product]');
                    let newProducts = [...collectionProducts];
                    switch (method) {
                        case 'best-selling':
                            newProducts.sort((a, b) => {
                                const aVal = a.getAttribute('data-best-selling') || 1;
                                const bVal = b.getAttribute('data-best-selling') || 1;
                                console.log('sorting by best-selling', aVal, bVal);
                                return aVal - bVal;
                            });
                            break;

                        case 'created-descending':
                            newProducts.sort((a, b) => {
                                const aVal = new Date(a.getAttribute('data-created'));
                                const bVal = new Date(b.getAttribute('data-created'));
                                console.log('sorting by crated-descending', aVal, bVal);
                                return bVal - aVal;
                            });
                            break;

                        case 'top-rated':
                            newProducts.sort((a, b) => {
                                const aVal = a.getAttribute('data-rating');
                                const bVal = b.getAttribute('data-rating');
                                console.log('sorting by rating', aVal, bVal);
                                return aVal - bVal;
                            });
                            break;
                            
                        case 'price-ascending':
                            newProducts.sort((a, b) => {
                                const aVal = a.getAttribute('data-price');
                                const bVal = b.getAttribute('data-price');
                                console.log('sorting by price-ascending', aVal, bVal);
                                return aVal - bVal;
                            });
                            break;
                        
                        case 'price-descending':
                            newProducts.sort((a, b) => {
                                const aVal = a.getAttribute('data-price');
                                const bVal = b.getAttribute('data-price');
                                console.log('sorting by price-descending', aVal, bVal);
                                return bVal - aVal;
                            });
                            break;
                    
                        default:
                            break;
                    }
                    console.log('sorted products in collection', collectionProducts, newProducts);
                    let index = 0;
                    newProducts.forEach(product => {
                        product.style.order = `${index}`;
                        index += 1;
                    });
                });
            }

            navTriggers.forEach(navTrigger => {
                navTrigger.addEventListener('click', () => {
                    const targetCollection = navTrigger.getAttribute('data-collection');
                    if (targetCollection) {
                        if (!navTrigger.classList.contains('is-active')) {
                            const otherNavTriggers = [...navTriggers].filter(trigger => { return trigger != navTrigger });
                            navTrigger.classList.add('is-active');
                            otherNavTriggers.forEach(trigger => {
                                trigger.classList.remove('is-active');
                            });
                            if (targetCollection == 'all') {
                                collectionBlocks.forEach(collectionBlock => {
                                    collectionBlock.classList.add('is-active');
                                });
                            } else {
                                collectionBlocks.forEach(collectionBlock => {
                                    const loopCollection = collectionBlock.getAttribute('data-collection');
                                    if (loopCollection == targetCollection) {
                                        collectionBlock.classList.add('is-active');
                                    } else {
                                        collectionBlock.classList.remove('is-active');
                                    }
                                });
                            }
                        }
                    }
                });
            });

            sortWraps.forEach(sortWrap => {
                const sortToggles = sortWrap.querySelectorAll('[js-collection-grid-sort-toggle]');
                const sortSelects = sortWrap.querySelectorAll('[js-collection-grid-sort-select]');
                const sortOverlays = sortWrap.querySelectorAll('[js-collection-grid-sort-overlay]');

                sortToggles.forEach(sortToggle => {
                    sortToggle.addEventListener('click', () => {
                        sortWrap.classList.toggle('is-open');
                    });
                });

                sortOverlays.forEach(sortOverlay => {
                    sortOverlay.addEventListener('click', (e) => {
                        if (e.target == e.currentTarget) {
                            console.log('sort closed by overlay');
                            sortWrap.classList.remove('is-open');
                        }
                    });
                });

                sortSelects.forEach(sortSelect => {
                    sortSelect.addEventListener('click', () => {
                        sortWrap.classList.remove('is-open');
                        if (!sortSelect.classList.contains('is-active')) {
                            const sortMethod = sortSelect.getAttribute('data-value');
                            if (sortMethod) {
                                const otherSelects = [...sortSelects].filter(select => { return select != sortSelect });
                                sortSelect.classList.add('is-active');
                                otherSelects.forEach(select => {
                                    select.classList.remove('is-active');
                                });
                                sortProducts(sortMethod);
                            }
                        }
                    });
                });
            });
        });
    });
}